// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__120bY","rootCenter":"LoadMoreObserver_rootCenter__2yCbz","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1DFvq"};